import React from 'react';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@wwe-portal/ui/components/dropdown';
import { RarityProps } from './market-items-popup/market-items-popup';
import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { Each } from '@wwe-portal/ui/components/utils';
import { cn } from '../../../../../packages/ui/lib/lib';

interface MarketItemsRarityDropdownProps {
  rarities: RarityProps[];
  active: {
    name: string;
    id?: number;
  };
  selectFilter: (item) => void;
  className?: string;
}
function MarketItemsRarityDropdown({
  rarities = [],
  active,
  selectFilter,
  className,
}: MarketItemsRarityDropdownProps) {
  const { isMobile } = useResponsive();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {!isMobile ? (
          <ClickableDiv
            className={cn(
              'bg-back300 text-text600 flex h-[46px] w-[150px] items-center justify-center rounded-lg border-[1px] border-solid border-[#6A73B5] px-5 py-2.5 text-center text-sm font-medium',
              className
            )}
          >
            <>
              {active.name !== 'Filter by Rarity' ? (
                <i className="icon-checkbox-rounded text-chetwodeBlue body-16 mr--5" />
              ) : (
                ''
              )}
              <span className="pr-30">{active.name}</span>
            </>
          </ClickableDiv>
        ) : (
          <ClickableDiv>
            <IcoMoonIcon
              iconName="filter-fill"
              className={cn('block size-6 md:hidden', className)}
            />
          </ClickableDiv>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        isQualMenuWidth={true}
        className="bg-bgColor34 text-inlineTextColor12 min-w-40"
        onCloseAutoFocus={(event) => {
          event.preventDefault();
        }}
      >
        <div className="no-scrollbar pointer-events-auto max-h-[360px] overflow-y-auto">
          <Each
            data={rarities}
            render={(item) => (
              <DropdownMenuItem
                className={cn(
                  'hover:bg-back300 h-8 cursor-pointer rounded px-2 capitalize',
                  {
                    'bg-back300': active.id === item.id,
                  }
                )}
                onClick={() => selectFilter(item)}
              >
                {item.name}
              </DropdownMenuItem>
            )}
          />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default MarketItemsRarityDropdown;
